import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.En';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.EnGb';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.De';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.FrFr';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.It';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.Es';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.Ru';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.No';
import '@bryntum/schedulerpro-thin/locales/schedulerpro.locale.Pt';
import { employeeLocaleToBryntumLocale } from './bryntumUtils';

export const mapLocaleToBryntumLocale = (locale: string) => {
  return employeeLocaleToBryntumLocale(locale);
};
